import { render, staticRenderFns } from "./CommunicationTab.vue?vue&type=template&id=0aa76b07"
import script from "./CommunicationTab.vue?vue&type=script&lang=js"
export * from "./CommunicationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports